// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyComponent_empty__o4zb5"};